// eslint-disable-next-line import/no-named-default
import { default as MasterUserPosition } from "./UserPosition";

export default MasterUserPosition;
